import React from 'react'

import amber from '@material-ui/core/colors/amber'
import red from '@material-ui/core/colors/red'
import IconButton from '@material-ui/core/IconButton'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import { withStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import PropTypes from 'prop-types'
/**
 * Get expansion panel wrapper
 */
import { connect } from 'react-redux'

import { showSnackbar } from './actions'

export const AUTO_HIDE_DURATION = 6000

// Optionally pass as type parameter in snackbarOptions
export const SNACKBAR_INFO = 'info' // Maps to the class name (styles)
export const SNACKBAR_WARNING = 'warning' // Maps to the class name (styles)
export const SNACKBAR_ERROR = 'error' // Maps to the class name (styles)

const styles = theme => ({
  root: {},
  info: {},
  warning: {
    backgroundColor: amber[700]
  },
  error: {
    backgroundColor: red[700]
  },
  xBtn: {
    padding: 4,
    color: 'grey'
  }
})

class PositionedSnackbar extends React.Component {
  handleClose = (evt, reason) => {
    // This prevents the auto close of an open previous snackbar causing a new one not to show
    if (reason === 'clickaway') {
      return
    }

    const { showSnackbar } = this.props
    const snackbarOptionsUpdate = { open: false }
    showSnackbar(snackbarOptionsUpdate)
  }

  render () {
    const { classes, snackbarOptions } = this.props

    if (isNil(snackbarOptions)) {
      console.error('Invalid snackbarOptions passed to PositionedSnackbar!')
      return null
    }

    const messageRaw = snackbarOptions?.message ?? ''
    // Handle both string messages and React elements to allow URL links in the message
    const message = typeof messageRaw === 'string' ? messageRaw.trim() : messageRaw
    if (!message) {
      return null
    }

    const vertical = get(snackbarOptions, 'vertical', 'bottom')
    const horizontal = get(snackbarOptions, 'horizontal', 'left')
    const open = get(snackbarOptions, 'open', true)
    const autoHideDuration = get(snackbarOptions, 'autoHideDuration', AUTO_HIDE_DURATION)
    const type = get(snackbarOptions, 'type', SNACKBAR_INFO).trim()
    const anchorOrigin = { vertical, horizontal }
    const action = get(snackbarOptions, 'action', undefined)

    const xBtn = (
      <IconButton
        key="close"
        aria-label="close"
        color="inherit"
        className={classes.xBtn}
        onClick={this.handleClose}
      >
        <CloseIcon />
      </IconButton>
    )
    const actions = (
      action
        ? [action, xBtn]
        : xBtn
    )

    return (
      <div>
        <Snackbar anchorOrigin={anchorOrigin} open={open} autoHideDuration={autoHideDuration} onClose={this.handleClose}>
          <SnackbarContent
            className={classes[type]}
            message={message}
            action={actions}
          />
        </Snackbar>
      </div>
    )
  }
}

PositionedSnackbar.propTypes = {
  classes: PropTypes.object.isRequired,
  snackbarOptions: PropTypes.object.isRequired,
  showSnackbar: PropTypes.func.isRequired
}

function mapStateToProps (state, ownProps) {
  return {
    snackbarOptions: state.snackbarOptions
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showSnackbar: snackbarOptions => {
      dispatch(showSnackbar(snackbarOptions))
    }
  }
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(PositionedSnackbar)
  )
)
